import { Dimensions, PixelRatio, Platform } from "react-native";

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get("window");
const wscale: number = SCREEN_WIDTH / 375;
const hscale: number = SCREEN_HEIGHT / 812;

export const normalize = (
  size: number,
  based: "width" | "height" = "width"
) => {
  const newSize = based === "height" ? size * hscale : size * wscale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

export const getFromSize = (value: number) => {
  return normalize(value);
};

export const normalizeHorizontal = (size: number) => {
  return normalize(size, "width");
};

export const normalizeVertical = (size: number) => {
  return normalize(size, "height");
};

export const normalizeFont = (size: number) => {
  return normalizeVertical(size) + (Platform.OS === "android" ? 2 : 0);
};